import React from "react";
import * as Icon from "react-feather";

import WComponent from "../common/WComponent";
import ToolsModal from "../clients/Tools/kit/ToolsModal";

import "./playbook-change-modal.css";

class PlaybookChangeModal extends WComponent {
	constructor(props) {
		super(props);
		this.state = {
			text: props.initialText || "",
			changeNote: "",
			isSaving: false,
			saveError: null,
		};
	}

	onConfirm = async () => {
		const { onConfirm } = this.props;
		const { text, changeNote } = this.state;
		await this.update({ isSaving: true, saveError: null });
		const saveError = await onConfirm({ text: text.trim(), changeNote: changeNote.trim() });
		await this.update({ isSaving: false, saveError: saveError || null });
	};

	renderFooter() {
		const { onClose, confirmLabel, textLabel, isDestructive } = this.props;
		const { text, changeNote, isSaving } = this.state;
		const hasText = !textLabel || text.trim().length > 0;
		const canConfirm = hasText && changeNote.trim().length > 0 && !isSaving;

		return (
			<>
				<span className="agent-change__footer-note">
					<Icon.GitCommit size={14} />
					Saved as a new version with your name
				</span>
				<div className="tk-modal-actions">
					<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>
						Cancel
					</button>
					<button
						type="button"
						className={isDestructive ? "tk-button tk-button--danger" : "tk-button tk-button--primary"}
						onClick={this.onConfirm}
						disabled={!canConfirm}
					>
						{isSaving ? "Saving…" : confirmLabel}
					</button>
				</div>
			</>
		);
	}

	render() {
		const { open, onClose, title, intro, textLabel, textRows = 6, textHelp } = this.props;
		const { text, changeNote, saveError } = this.state;

		return (
			<ToolsModal open={open} onClose={onClose} title={title} width={textLabel ? 640 : 520} footer={this.renderFooter()}>
				{intro && <p className="agent-change__intro">{intro}</p>}
				{textLabel && (
					<div className="tk-form-field">
						<div className="tk-form-label">
							{textLabel}
							<span className="tk-form-required">*</span>
						</div>
						<textarea
							className="tk-input agent-change__text"
							rows={textRows}
							value={text}
							onChange={event => this.update({ text: event.target.value })}
							autoFocus
						/>
						{textHelp && <div className="tk-form-help">{textHelp}</div>}
					</div>
				)}
				<div className="tk-form-field">
					<div className="tk-form-label">
						What changed and why<span className="tk-form-required">*</span>
					</div>
					<input
						className="tk-input"
						value={changeNote}
						onChange={event => this.update({ changeNote: event.target.value })}
						maxLength={300}
						autoFocus={!textLabel}
						placeholder="e.g. Dental clinics book lab fees to cost of sales"
					/>
					<div className="tk-form-help">Shown in the version history next to your name.</div>
				</div>
				{saveError && (
					<div className="tk-notice tk-notice--danger">
						<div className="tk-notice__title">
							<Icon.AlertTriangle size={14} />
							{saveError}
						</div>
					</div>
				)}
			</ToolsModal>
		);
	}
}

export default PlaybookChangeModal;
